import React from 'react';


import ScrollableTabsButtonVisible from "./Tab";
import { useLocation } from 'react-router-dom';

const Index = ({tabs,tabtitle}) => {
    const location = useLocation();
    const { submenu } = location.state || {};
  
    const data= submenu?.map((item)=>({label:item.text,component:item.path})
    );
    return (
            <ScrollableTabsButtonVisible title={tabtitle} tabs={tabs} />
    );
}
export default Index;